(function() {

	// MODULE
	var CardChecker = (function() {
		var __private = {
			checkbox: null,
			type: "checkbox",
			buttonSelector: "input.btnPay[type='submit']",
			textCheckAttr: "data-text-on-pay-existing-card-check",
			textUncheckAttr: "data-text-on-pay-existing-card-uncheck",

			set(checkbox, options) {
				if(checkbox instanceof HTMLInputElement && checkbox.type === this.type) this.checkbox = checkbox;
				
				if(options instanceof Object) {
					if(options.hasOwnProperty("buttonSelector"))  this.buttonSelector  = options.buttonSelector;
					if(options.hasOwnProperty("textCheckAttr"))   this.textCheckAttr   = options.textCheckAttr;
					if(options.hasOwnProperty("textUncheckAttr")) this.textUncheckAttr = options.textUncheckAttr;
				}
			},

			listener() {
				if(this.checkbox instanceof HTMLInputElement) {
					this.checkbox.addEventListener("change", function() {
						__private.switch();
					});
				}
			},

			switch() {
				var form;
				var button;
				var checkText;
				var uncheckText;
				
				if(__private.checkbox instanceof HTMLInputElement) {
					form = __private.checkbox.form;
					button = form.querySelector(__private.buttonSelector);

					if(button instanceof HTMLElement) {
						checkText   = button.getAttribute(__private.textCheckAttr);
						uncheckText = button.getAttribute(__private.textUncheckAttr);

						if(__private.checkbox.checked) button.value = checkText;
						else button.value = uncheckText;
					}
				}
			}
		};

		return {
			init(checkbox, options) {
				__private.set(checkbox, options);
				__private.switch();
				__private.listener();
			}
		};
	})();


	// RUN
	document.addEventListener("DOMContentLoaded", function() {
		var cardGuid = document.getElementById("existing-card-selector-container");

		if(cardGuid instanceof HTMLElement) {
			let checkbox = document.querySelector("input[type='checkbox'][name='old_card']");

			CardChecker.init(checkbox, {
				buttonSelector: "input.btnPay[type='submit']",
				textCheckAttr: "data-text-on-pay-existing-card-check",
				textUncheckAttr: "data-text-on-pay-existing-card-uncheck"
			});
		}
	});
	
})();